import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import App from './App.jsx'
import { store } from './store'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
// MSW setup - always enable in development
// MSW is disabled - using real API endpoints
if (import.meta.env.DEV && import.meta.env.VITE_MSW_ENABLED === 'true') {
  // Only start MSW if explicitly enabled
  const startMSW = async () => {
    try {
      const { worker } = await import('./mocks/browser.js')
      await worker.start({
        onUnhandledRequest: 'bypass'
      })
      console.log('✅ MSW worker started successfully')
    } catch (error) {
      console.error('❌ Failed to start MSW worker:', error)
    }
  }
  
  startMSW()
} else {
  console.log('🚀 MSW disabled - using real API endpoints')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>,
)
